import { Button, Card } from "antd";
import { Products } from "@modules";
import { Breadcrumb } from "@components";
import { Link } from "react-router-dom";
import { PlusOutlined } from "@ant-design/icons";

export default function ProductsPage() {
  return (
    <div className="container max-content">
      <Breadcrumb data={[{ title: "Products", href: "/products" }]} />
      <div className="flex justify-between items-center flex-wrap mb-5">
        <h1 className="text-3xl">Products</h1>
        <Link to="/products/new">
          <Button className="m-0" icon={<PlusOutlined />} type="primary">
            Add New
          </Button>
        </Link>
      </div>
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12">
          <Card bordered={false}>
            <Products.List />
          </Card>
        </div>
      </div>
    </div>
  );
}
